// extracted by mini-css-extract-plugin
export default {"page-layout":"styles_page-layout__Wz9Av"};